// extracted by mini-css-extract-plugin
export default {"timeline":"DataProcessTimeline_timeline__q8AuH","label":"DataProcessTimeline_label__w4pIR","duration":"DataProcessTimeline_duration__mh+BG"};